module.exports = "../../../../platform/assets/pageMainIcon/business_baobiaochaxunlei5.svg";